import { render, staticRenderFns } from "./CreateTypeStageFromList.vue?vue&type=template&id=7954fc5b&"
import script from "./CreateTypeStageFromList.vue?vue&type=script&lang=js&"
export * from "./CreateTypeStageFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports